<div class="flex flex-col justify-center items-center mt-100" *ngIf="chooseTenant">
    <img src="/assets/images/combined_shape.png" alt="Choose tenant" class="w-40">
    <div class="flex m-20 choose-tenant">{{'TENANT_LAYOUT.CHOOSE_TENANT_TO_VIEW' | transloco}}</div>
</div>